import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, LeafIcon, BadgeCheckIcon } from 'lucide-react';
export function HeroSection() {
  const cartUrl = 'https://cristobalchiara.online/cart/add?id=57063079969093&quantity=1';
  return <section className="pt-20 md:pt-24 pb-16 px-4 bg-[#FAF7F2]" data-id="element-72">
      <div className="max-w-7xl mx-auto" data-id="element-73">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-74">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-75">
            <div className="flex items-center gap-1 mb-4" data-id="element-76">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#C9A96E] text-[#C9A96E]" data-id="element-77" />)}
              <span className="ml-2 text-sm text-[#2D2926]/70 flex items-center gap-1" data-id="element-78">
                <BadgeCheckIcon className="w-4 h-4 text-[#7C9A6E]" data-id="element-79" />
                Compra Verificada
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2926] mb-6 leading-tight" data-id="element-80">
              MENOPAUSIA EN CALMA
            </h1>

            <p className="text-xl md:text-2xl text-[#7C9A6E] font-medium mb-6 leading-relaxed" data-id="element-81">
              Equilibra tus hormonas, reduce la inflamación y vuelve a sentirte
              plena de energía en menos de 21 días
            </p>

            <p className="text-lg text-[#2D2926]/80 mb-8 leading-relaxed" data-id="element-82">
              Una guía integral con nutrición, hábitos y herramientas prácticas
              para que dejes de sentirte desbordada por los síntomas y empieces
              a vivir esta etapa con claridad, bienestar y confianza.
            </p>

            <motion.a href={cartUrl} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#7C9A6E] hover:bg-[#6B8F5E] text-white font-semibold text-lg px-8 py-4 rounded-full shadow-lg transition-colors" data-id="element-83">
              ¡QUIERO MI GUÍA AHORA!
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-84">
            <div className="aspect-[4/5] rounded-2xl shadow-2xl relative overflow-hidden" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/n1g1nLCAtkuXFDdztGQg5D/20260303_1357_Image_Generation_remix_01kjta1ns7f79vkr2jyvcjcwbc.png" alt="Menopausia en Calma - Guía Digital Completa" className="w-full h-full object-cover rounded-2xl" data-id="element-86" />
              <div className="absolute top-4 right-4 bg-[#A0525A] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-87">
                BESTSELLER
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}